import { useState } from 'react'

import { ProbateEstate } from 'lib/models/probate-estate'
import { ProbateCase } from 'lib/models/probate-case'

import Deceased from './deceased'
import WillOrIntestacy from './will-or-intestacy'
import Executors from './executors'
import Beneficiaries from './beneficiaries'
import Part from '../components/part'
import { QUESTIONNAIRE_SECTIONS } from '../constants'

type HandleSave = (event: { name: string; value: unknown }) => void

type Props = {
  probateEstate: ProbateEstate
  probateCase: ProbateCase
  saveProbateEstateField: HandleSave
  saveProbateCaseField: HandleSave
}

const People = ({
  probateEstate,
  probateCase,
  saveProbateEstateField,
  saveProbateCaseField,
}: Props) => {
  const [hasWill, setHasWill] = useState<boolean | undefined>(
    probateEstate.attributes.hasWill ?? undefined
  )

  return (
    <Part
      id={QUESTIONNAIRE_SECTIONS.PEOPLE.id}
      heading={QUESTIONNAIRE_SECTIONS.PEOPLE.heading}
      description="Personal details about the deceased and key contacts needed for managing the estate."
    >
      <Deceased
        probateEstate={probateEstate}
        probateCase={probateCase}
        saveProbateEstateField={saveProbateEstateField}
        saveProbateCaseField={saveProbateCaseField}
      />
      <WillOrIntestacy
        probateEstate={probateEstate}
        saveProbateEstateField={saveProbateEstateField}
        onHasWillChange={setHasWill}
      />
      <Executors hasWill={hasWill} />
      <Beneficiaries />
    </Part>
  )
}

export default People
